import { useEffect, useMemo, useState, useRef } from "react";

/**
 * Edit these values when you want a notification.
 * Tip: bump `id` to re-show a new notification to users who dismissed the previous one.
 */
const NOTIFICATION = {
  enabled: false,
  id: "alert-2026-02-08",
  // text: "Premium giveaway is live. Join our Discord to enter and get the latest model updates, tips, and announcements",
  // text: "OkeyBot Premium giveaway ends in 1 day. Click to join our official Discord server and enter in the #giveaways channel",
  text: "NEW: Grok Imagine Video and Image models are now available with xAI API keys.",
  // cta: "Join our Discord Server",
  // url: "https://discord.gg/WAgvT7QxWx",
  cta: "Try Now",
  url: "/dashboard/models",
  variant: "accent", // accent | info | success | warning
  dismissible: true,
};

export default function NotificationBar({ trackEvent }) {
  const n = NOTIFICATION;
  const barRef = useRef(null);

  const storageKey = useMemo(
    () => `ob_notification_dismissed:${n.id || "default"}`,
    [n.id]
  );

  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!n.dismissible) return;
    try {
      setDismissed(localStorage.getItem(storageKey) === "1");
    } catch {
      setDismissed(false);
    }
  }, [n.dismissible, storageKey]);

  const visible = !!n.enabled && !!n.text && !!n.url && !(n.dismissible && dismissed);


  useEffect(() => {

    if (!visible) return;
    function applyOffset() {
      const el = barRef.current;
      if (!el) return;
      const h = Math.ceil(el.getBoundingClientRect().height || 0);
      document.documentElement.style.setProperty("--notification-bar-offset", `${h}px`);
    }

    applyOffset();
    window.addEventListener("resize", applyOffset);
    return () => {
      window.removeEventListener("resize", applyOffset);
      document.documentElement.style.removeProperty("--notification-bar-offset");
    };
  }, [visible]);

  if (!visible) return null;

  function dismiss() {
    try {
      localStorage.setItem(storageKey, "1");
    } catch {
      // ignore
    }
    setDismissed(true);
    if (typeof trackEvent === "function") trackEvent("notification_dismiss", { id: n.id });
  }

  return (
    <div
      ref={barRef}
      className={`notification-bar notification-bar-${n.variant || "accent"}`}
      role="region"
      aria-label="Site notification"
    >
      <div className="notification-bar-inner">
        <div className="notification-bar-left">
          <span className="notification-bar-text">{n.text}</span>
        </div>
        <div className="notification-bar-right">
          <a
            className="notification-bar-cta"
            href={n.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              if (typeof trackEvent === "function") trackEvent("notification_click", { id: n.id });
            }}
          >
            {n.cta || "Learn more"}
            <svg width={16} height={16} fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
            </svg>
          </a>

          {n.dismissible && (
            <button className="notification-bar-close" onClick={dismiss} aria-label="Dismiss notification">
              ✕
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
